import all from './all';

export default {
  all,
};



// WEBPACK FOOTER //
// ./src/app/services/licensePermitType/index.js